







































import { Component, PropSync, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class XBtnOperativeActiveInactive extends Vue {
  @PropSync("activo") act!: boolean;
}
